// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"65":"93847ef9","72":"db70203a","377":"cf079d00"}[chunkId] + ".css";
};